// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/subHeader.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__-kTiC {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    margin-top: 2%;
    padding: 3% 0px;
    border-radius: 10px 10px 0px 0px;
}

.style_subcontainer__3tnY0 {
    display: flex;
    flex: 2 1;
    flex-direction: row;
    align-items: flex-start;
    background-color: white;
    flex-wrap: wrap;
    margin: 10px 25px;
    width: 94%;
}

.style_inputContainer__ygmtT {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex-basis: 33%;
}

.style_inputLabel__Hzdij {
    font-size: 14px;
    font-weight: 600;
}

.style_input__kUXuj {
    width: 90%;
    height: 28px;
    border-radius: 4px;
    border: 1px solid lightgray;
    padding: 2px 8px;
}

.style_rangeText__6TmJZ {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.01em;
    text-align: left;
    color: darkgray;
}

.style_button__sCAJ2 {
    background-color: white;
    border: 1px solid lightgray;
    padding: 8px 20%;
    text-align: center;
    text-decoration: none;
    display: flex;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    width: 100%;
    margin-right: 10px;
    min-width: 100px;
}

.style_buttonIcon__hNGQY {
    margin-left: 4px;
    height: 18px;
    width: 18px
}

.style_buttonFilled__U8mtZ {
    color: white;
    background-color: #38566D;
}

.style_buttonContainer__yfYmA {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.style_buttonSection__Ilo57 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 33%;
    margin-right: 3px;
    flex-wrap: wrap;
}

.style_margin_40__kOmjH {
    margin-right: 5px
}

.style_margin_20__ZHpSJ {
    margin-right: 20px
}

.style_dropdown__zJ0ZQ {
    width: 95%;
    height: 35px;
    border-radius: 4px;
    border: 1px solid lightgray;
    /* padding: 6px 8px; */
    display: grid;
    align-items: center;
    position: relative;
    grid-template-areas: "select";
    flex-basis: 33%;
}

.style_dropdown__zJ0ZQ::after {
    content: "";
    width: 0.8em;
    height: 0.5em;
    background-color: #1C1B1F;
    clip-path: polygon(100% 0%, 0 0%, 50% 100%);
    justify-self: end;
    grid-area: select;
    margin-right: 8px;
}

.style_tooltip__YmBX5 {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.style_dropdownValue__YTFh8 {
    margin: 20px, 5px
}

.style_subHeaderImg__wQiAD {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.style_subHeader__p7u6G {
    padding: 10px 30px;
    color: white;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
}

.style_header__fkjOy {
    background-color: white;
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 32px;
    font-weight: 600;
    letter-spacing: -1px;
}

.style_img1__wwFuq {
    margin-left: 10px;
}

.style_img2__PX130 {
    margin-left: 40px;
}

.style_submitButton__PQdmK {
    background-color: black;
    border: 1px solid black;
    padding: 10px 18px;
    text-align: center;
    text-decoration: none;
    display: flex;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    margin-right: 15px;
    color: white;
    font-size: 16px;
    font-weight: 500;
}

.style_submitSection__SVNK5 {
    border-top: 1px solid lightgray;
    align-items: center;
    display: flex;
    flex-direction: row;
    background-color: white;
    padding: 20px 10px;
    justify-content: flex-end;
    border-radius: 0px 0px 10px 10px;
}

.style_formHeader__U3QG1 {
    margin: 0% 2%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    border-bottom: 1px solid lightgray;
    padding: 30px 0px
}

.style_formTitle__sjsL1 {
    font-size: 32px;
    font-weight: 700;
    margin: 20px 5px
}

.style_formContainer__N8sUB {
    margin: 0% 5% 8% 5%
}

.style_notesHeader__EdfKU {
    font-size: 16px;
    font-weight: 700;
}

.style_notesSection__Kz5la {
    margin: 30px 0px
}

.style_notesContent__Eb6g4 {
    font-size: 14px;
    font-weight: 400;
    margin-top: 15px;
    color: darkslategray
}

.style_notesSecondSection__z2zOo {
    margin: 30px 0px 40px 0px;
    width: 80%;
}

.style_dot__wAsjF {
    border-width: 1px;
    border-radius: 10px;
    background-color: black;
    width: 8px;
    height: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4px 8px;
}

.style_riskSection__kR\\+zj {
    font-size: 24px;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 6px 0px;
    width: 100%
}

.style_riskLabel__9-yqN {
    width: 30%
}

.style_arrow__i1hdU {
    width: 30px;
    height: 30px;
    margin: 0px 40px 0px 0px;
}

.style_riskValue__ki2Vi {
    font-weight: 800;
    width: 60%
}

.style_riskContainer__t9lMN {
    padding: 1% 0% 1% 5%;
    width: 90%;
    flex-direction: column;
}

.style_riskButton__ihLDD {
    border: 0px;
    width: 94%;
    padding: 0px;
}

.style_phoneLabel__6oNqc {
    margin: 0px;
    width: auto;
    justify-content: center;
    padding: 35px 12px;
    flex-direction: row;
    flex-wrap: wrap;
}

.style_phoneInput__0xJl8 {
    border-radius: 22px;
    width: 200px;
    height: 30px;
    border: 1px solid lightgray;
    padding: 4px 15px;
    margin: 0px 20px;
}

.style_prrLabel__-vhNA {
    font-size: 24px;
    font-weight: 700;
    margin: 20px 0px
}

.style_prrContainer__dznZO {
    border-radius: 10px;
    padding: 0px
}

.style_blueSection__yIXNV {
    background-color: #2F3273;
    width: 96%;
    border-radius: 10px 10px 0px 0px;
    padding: 30px 0px 10px 50px;
    font-size: 14px;
    font-weight: 600;
    color: white;
}

.style_blueContent__VWeia {
    font-size: 24px;
    margin: 10px 0px;
}

.style_prrContent__zdvGP {
    width: 96%;
    padding: 0px 0px 30px 50px;
    font-size: 14px;
    font-weight: 400;
}

.style_toggleSection__nhx5N {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 50%
}

.style_errorText__m\\+eyR {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.01em;
    text-align: left;
    color: #C73C2A;
}

.style_errorPh__Y1HmD {
    text-align: center;
}

.style_successMsg__S3C7E {
    color: darkgreen
}

.style_headerImg__COv\\+c {
    width: auto
}

.style_phoneText__TuBXB {
    font-size: 22px;
    font-weight: 500;
}

@media screen and (max-width: 600px) {
    .style_header__fkjOy {
        font-size: 16px;
    }

    .style_button__sCAJ2 {
        min-width: 80px;
        padding: 8px 10%;
    }

    .style_inputContainer__ygmtT {
        flex-basis: 100%;
    }

    .style_buttonSection__Ilo57 {
        width: 100%;
    }

    .style_riskSection__kR\\+zj {
        font-size: 14px;
    }

    .style_arrow__i1hdU {
        margin: 0;
    }

    .style_submitButton__PQdmK {
        margin: 4px 0px;
    }

    .style_headerImg__COv\\+c {
        width: 45%
    }

    .style_dropdown__zJ0ZQ {
        width: 90%
    }

    .style_blueSection__yIXNV {
        width: auto;
    }

    .style_phoneText__TuBXB {
        font-size: 12px;
        margin-bottom: 4px;
    }

    .style_prrLabel__-vhNA {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/style.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,2CAA2C;IAC3C,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,yDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gCAAgC;IAChC,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n    margin-top: 2%;\n    padding: 3% 0px;\n    border-radius: 10px 10px 0px 0px;\n}\n\n.subcontainer {\n    display: flex;\n    flex: 2;\n    flex-direction: row;\n    align-items: flex-start;\n    background-color: white;\n    flex-wrap: wrap;\n    margin: 10px 25px;\n    width: 94%;\n}\n\n.inputContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    flex-basis: 33%;\n}\n\n.inputLabel {\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.input {\n    width: 90%;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid lightgray;\n    padding: 2px 8px;\n}\n\n.rangeText {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.01em;\n    text-align: left;\n    color: darkgray;\n}\n\n.button {\n    background-color: white;\n    border: 1px solid lightgray;\n    padding: 8px 20%;\n    text-align: center;\n    text-decoration: none;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n    width: 100%;\n    margin-right: 10px;\n    min-width: 100px;\n}\n\n.buttonIcon {\n    margin-left: 4px;\n    height: 18px;\n    width: 18px\n}\n\n.buttonFilled {\n    color: white;\n    background-color: #38566D;\n}\n\n.buttonContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.buttonSection {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    width: 33%;\n    margin-right: 3px;\n    flex-wrap: wrap;\n}\n\n.margin_40 {\n    margin-right: 5px\n}\n\n.margin_20 {\n    margin-right: 20px\n}\n\n.dropdown {\n    width: 95%;\n    height: 35px;\n    border-radius: 4px;\n    border: 1px solid lightgray;\n    /* padding: 6px 8px; */\n    display: grid;\n    align-items: center;\n    position: relative;\n    grid-template-areas: \"select\";\n    flex-basis: 33%;\n}\n\n.dropdown::after {\n    content: \"\";\n    width: 0.8em;\n    height: 0.5em;\n    background-color: #1C1B1F;\n    clip-path: polygon(100% 0%, 0 0%, 50% 100%);\n    justify-self: end;\n    grid-area: select;\n    margin-right: 8px;\n}\n\n.tooltip {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.dropdownValue {\n    margin: 20px, 5px\n}\n\n.subHeaderImg {\n    background-image: url('../assets/subHeader.svg');\n}\n\n.subHeader {\n    padding: 10px 30px;\n    color: white;\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.header {\n    background-color: white;\n    padding: 10px 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 32px;\n    font-weight: 600;\n    letter-spacing: -1px;\n}\n\n.img1 {\n    margin-left: 10px;\n}\n\n.img2 {\n    margin-left: 40px;\n}\n\n.submitButton {\n    background-color: black;\n    border: 1px solid black;\n    padding: 10px 18px;\n    text-align: center;\n    text-decoration: none;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 25px;\n    margin-right: 15px;\n    color: white;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.submitSection {\n    border-top: 1px solid lightgray;\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    background-color: white;\n    padding: 20px 10px;\n    justify-content: flex-end;\n    border-radius: 0px 0px 10px 10px;\n}\n\n.formHeader {\n    margin: 0% 2%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-size: 20px;\n    font-weight: 600;\n    border-bottom: 1px solid lightgray;\n    padding: 30px 0px\n}\n\n.formTitle {\n    font-size: 32px;\n    font-weight: 700;\n    margin: 20px 5px\n}\n\n.formContainer {\n    margin: 0% 5% 8% 5%\n}\n\n.notesHeader {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.notesSection {\n    margin: 30px 0px\n}\n\n.notesContent {\n    font-size: 14px;\n    font-weight: 400;\n    margin-top: 15px;\n    color: darkslategray\n}\n\n.notesSecondSection {\n    margin: 30px 0px 40px 0px;\n    width: 80%;\n}\n\n.dot {\n    border-width: 1px;\n    border-radius: 10px;\n    background-color: black;\n    width: 8px;\n    height: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 4px 8px;\n}\n\n.riskSection {\n    font-size: 24px;\n    font-weight: 500;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 6px 0px;\n    width: 100%\n}\n\n.riskLabel {\n    width: 30%\n}\n\n.arrow {\n    width: 30px;\n    height: 30px;\n    margin: 0px 40px 0px 0px;\n}\n\n.riskValue {\n    font-weight: 800;\n    width: 60%\n}\n\n.riskContainer {\n    padding: 1% 0% 1% 5%;\n    width: 90%;\n    flex-direction: column;\n}\n\n.riskButton {\n    border: 0px;\n    width: 94%;\n    padding: 0px;\n}\n\n.phoneLabel {\n    margin: 0px;\n    width: auto;\n    justify-content: center;\n    padding: 35px 12px;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.phoneInput {\n    border-radius: 22px;\n    width: 200px;\n    height: 30px;\n    border: 1px solid lightgray;\n    padding: 4px 15px;\n    margin: 0px 20px;\n}\n\n.prrLabel {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 20px 0px\n}\n\n.prrContainer {\n    border-radius: 10px;\n    padding: 0px\n}\n\n.blueSection {\n    background-color: #2F3273;\n    width: 96%;\n    border-radius: 10px 10px 0px 0px;\n    padding: 30px 0px 10px 50px;\n    font-size: 14px;\n    font-weight: 600;\n    color: white;\n}\n\n.blueContent {\n    font-size: 24px;\n    margin: 10px 0px;\n}\n\n.prrContent {\n    width: 96%;\n    padding: 0px 0px 30px 50px;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.toggleSection {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 50%\n}\n\n.errorText {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.01em;\n    text-align: left;\n    color: #C73C2A;\n}\n\n.errorPh {\n    text-align: center;\n}\n\n.successMsg {\n    color: darkgreen\n}\n\n.headerImg {\n    width: auto\n}\n\n.phoneText {\n    font-size: 22px;\n    font-weight: 500;\n}\n\n@media screen and (max-width: 600px) {\n    .header {\n        font-size: 16px;\n    }\n\n    .button {\n        min-width: 80px;\n        padding: 8px 10%;\n    }\n\n    .inputContainer {\n        flex-basis: 100%;\n    }\n\n    .buttonSection {\n        width: 100%;\n    }\n\n    .riskSection {\n        font-size: 14px;\n    }\n\n    .arrow {\n        margin: 0;\n    }\n\n    .submitButton {\n        margin: 4px 0px;\n    }\n\n    .headerImg {\n        width: 45%\n    }\n\n    .dropdown {\n        width: 90%\n    }\n\n    .blueSection {\n        width: auto;\n    }\n\n    .phoneText {\n        font-size: 12px;\n        margin-bottom: 4px;\n    }\n\n    .prrLabel {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__-kTiC`,
	"subcontainer": `style_subcontainer__3tnY0`,
	"inputContainer": `style_inputContainer__ygmtT`,
	"inputLabel": `style_inputLabel__Hzdij`,
	"input": `style_input__kUXuj`,
	"rangeText": `style_rangeText__6TmJZ`,
	"button": `style_button__sCAJ2`,
	"buttonIcon": `style_buttonIcon__hNGQY`,
	"buttonFilled": `style_buttonFilled__U8mtZ`,
	"buttonContainer": `style_buttonContainer__yfYmA`,
	"buttonSection": `style_buttonSection__Ilo57`,
	"margin_40": `style_margin_40__kOmjH`,
	"margin_20": `style_margin_20__ZHpSJ`,
	"dropdown": `style_dropdown__zJ0ZQ`,
	"tooltip": `style_tooltip__YmBX5`,
	"dropdownValue": `style_dropdownValue__YTFh8`,
	"subHeaderImg": `style_subHeaderImg__wQiAD`,
	"subHeader": `style_subHeader__p7u6G`,
	"header": `style_header__fkjOy`,
	"img1": `style_img1__wwFuq`,
	"img2": `style_img2__PX130`,
	"submitButton": `style_submitButton__PQdmK`,
	"submitSection": `style_submitSection__SVNK5`,
	"formHeader": `style_formHeader__U3QG1`,
	"formTitle": `style_formTitle__sjsL1`,
	"formContainer": `style_formContainer__N8sUB`,
	"notesHeader": `style_notesHeader__EdfKU`,
	"notesSection": `style_notesSection__Kz5la`,
	"notesContent": `style_notesContent__Eb6g4`,
	"notesSecondSection": `style_notesSecondSection__z2zOo`,
	"dot": `style_dot__wAsjF`,
	"riskSection": `style_riskSection__kR+zj`,
	"riskLabel": `style_riskLabel__9-yqN`,
	"arrow": `style_arrow__i1hdU`,
	"riskValue": `style_riskValue__ki2Vi`,
	"riskContainer": `style_riskContainer__t9lMN`,
	"riskButton": `style_riskButton__ihLDD`,
	"phoneLabel": `style_phoneLabel__6oNqc`,
	"phoneInput": `style_phoneInput__0xJl8`,
	"prrLabel": `style_prrLabel__-vhNA`,
	"prrContainer": `style_prrContainer__dznZO`,
	"blueSection": `style_blueSection__yIXNV`,
	"blueContent": `style_blueContent__VWeia`,
	"prrContent": `style_prrContent__zdvGP`,
	"toggleSection": `style_toggleSection__nhx5N`,
	"errorText": `style_errorText__m+eyR`,
	"errorPh": `style_errorPh__Y1HmD`,
	"successMsg": `style_successMsg__S3C7E`,
	"headerImg": `style_headerImg__COv+c`,
	"phoneText": `style_phoneText__TuBXB`
};
export default ___CSS_LOADER_EXPORT___;
